<template>
  <div class="animated fadeIn kertaskerja">
    <b-card>
      <div slot="header">
        Kertas Kerja Konsolidasi
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            v-if="enableLockPeriode == true"
            @click="showUnitPeriode = true"
          >
            <i class="fa fa-lock"></i>
            Unit Bisnis Periode
          </button>
          <b-dropdown text="Add Jurnal Eliminasi" variant="primary mr-1">
            <b-dropdown-item @click="addjv_auto()"
              >Otomatis Template</b-dropdown-item
            >
            <b-dropdown-item @click="addjv()">Manually Input </b-dropdown-item>
          </b-dropdown>

          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-2 pr-2">Periode</span>
            </b-input-group-prepend>
            <vue-monthly-picker
              v-model="frmdata.periode"
              dateFormat="MMMM YYYY"
              :monthLabels="monthLabels"
              @selected="onChangeMonth"
              style="width: 332px !important"
            ></vue-monthly-picker>
            <b-button class="btn btn-success ml-2" @click="process()">
              <i class="fa fa-play"></i> Open</b-button
            >
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group size="sm" v-if="filterShow == 'Hide'">
            <b-form-checkbox
              v-model="filterShow"
              value="Hide"
              unchecked-value="Show"
              switch
              class="pt-1"
            ></b-form-checkbox>
            <b-input-group-prepend>
              <span class="pt-1 pr-2">
                <b> {{ filterShow }}</b> Filter
              </span>
            </b-input-group-prepend>
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
          <b-input-group size="sm" v-else>
            <b-form-checkbox
              v-model="filterShow"
              value="Hide"
              unchecked-value="Show"
              switch
              class="pt-1"
            >
            </b-form-checkbox>
            <b-input-group-prepend>
              <span class="pt-1 pr-2">
                <b> {{ filterShow }}</b> Filter
              </span>
            </b-input-group-prepend>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
        <div class="report-wraper" :key="dataReady">
          <table style="width: 100%">
            <thead>
              <tr>
                <th style="width: 100px" rowspan="2">Account Code</th>
                <th rowspan="2" style="min-width: 250px">Account Name</th>
                <th style="text-align: center" :colspan="companies.length">
                  BUKU UNIT BISNIS
                </th>
                <th style="text-align: center; max-width: 150px" rowspan="2">
                  TOTAL BUKU UNIT BISNIS
                </th>
                <th style="text-align: center; max-width: 250px" colspan="2">
                  JURNAL ELIMINASI
                </th>
                <th style="text-align: center; max-width: 150px" rowspan="2">
                  BUKU KONSOLIDASI
                </th>
              </tr>
              <tr>
                <th
                  :style="`backgroundColor:${kol.compcolor}; font-size:smaller; font-weight: normal !important; max-width:150px;`"
                  v-for="kol in companies"
                  :key="kol.compcode"
                  class="text-center"
                >
                  {{ kol.company }}
                </th>
                <th style="text-align: center; max-width: 150px">Debit</th>
                <th style="text-align: center; max-width: 150px">Credit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in wsDisplayed" :key="row.kodeacc">
                <td :class="row.kelas">{{ row.kodeacc }}</td>
                <td :class="row.kelas">
                  <span
                    v-if="row.judul == 'Y'"
                    style="font-weight: bold"
                    :style="`margin-left:${row.level_ * 5}px`"
                    >{{ row.namaacc }}</span
                  >
                  <span v-else :style="`margin-left:${row.level_ * 5}px`">{{
                    row.namaacc
                  }}</span>
                </td>
                <td
                  :class="row.kelas"
                  :style="`backgroundColor:${kol.compcolor};`"
                  class="text-right"
                  v-for="kol in companies"
                  :key="kol.compcode"
                >
                  {{ row[kol.namakolom] | numFormat }}
                </td>
                <td :class="row.kelas" style="text-align: right">
                  <span v-if="row.judul == 'Y'" style="font-weight: bold">{{
                    row.awal | numFormat
                  }}</span>
                  <span v-else>{{ row.awal | numFormat }}</span>
                </td>
                <td :class="row.kelas" style="text-align: right">
                  {{ row.debet | numFormat }}
                </td>
                <td :class="row.kelas" style="text-align: right">
                  {{ row.kredit | numFormat }}
                </td>
                <td :class="row.kelas" style="text-align: right">
                  <span v-if="row.judul == 'Y'" style="font-weight: bold">{{
                    row.akhir | numFormat
                  }}</span>
                  <span v-else>{{ row.akhir | numFormat }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-row class="mt-2">
          <b-col cols="4">
            <div>
              Showing {{ (frmdata.page - 1) * frmdata.limit + 1 }} to
              <span v-if="frmdata.page * frmdata.limit > frmdata.total">{{
                frmdata.total
              }}</span>
              <span v-else>{{ frmdata.page * frmdata.limit }}</span> of
              {{ frmdata.total }} entries
            </div>
          </b-col>
          <b-col cols="4">
            <b-input-group>
              <b-input-group-prepend class="mb-0"
                ><span class="p-2">Limit per page</span></b-input-group-prepend
              >
              <input
                type="number"
                style="width: 80px"
                v-model="frmdata.limit"
                size="sm"
              />
              <b-form-checkbox
                class="pt-2"
                value="1"
                unchecked-value="0"
                @change="showAll"
                >Show All</b-form-checkbox
              >
            </b-input-group>
          </b-col>
          <b-col cols="4">
            <b-pagination
              align="right"
              :total-rows="frmdata.total"
              :per-page="frmdata.limit"
              v-model="frmdata.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuCoaShow"
      size="lg"
      :hide-footer="true"
      title="List of GL Account"
      :centered="true"
    >
      <lku-coa
        @click="onSelectLkuCoa"
        :tahun="tahun"
        :key="tahun"
        :allowHeader="true"
      ></lku-coa>
    </b-modal>

    <b-modal
      v-model="showUnitPeriode"
      header-bg-variant="primary"
      title="Unit Bisnis Periode Status"
      size="lg"
      :centered="true"
      ok-only
    >
      <b-table
        class="mb-0"
        ref="tblUnitConsol"
        outlined
        responsive
        hover
        small
        :items="companies"
        :fields="tblUnitFields"
        :per-page="20"
      >
        <template v-slot:cell(nomor)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(company)="data">
          {{ data.item.company }}
          <span
            v-if="data.item.consolidated == 1"
            style="background-color: yellow"
            >(CONSOLIDATED)</span
          >
        </template>

        <template v-slot:cell(status)="data">
          <span
            v-if="data.item.tglaktifconsol == tglaktifconsol"
            style="font-weight: bolder"
            ><i class="fa fa-lock"></i> Locked</span
          >
          <span v-else> <i class="fa fa-unlock"></i> Open</span>
        </template>
        <template v-slot:cell(action)="data">
          <span v-if="data.item.erpsource == 0" style="font-weight: bolder"
            >N/A</span
          >
          <div
            class="text-center"
            v-if="data.item.consolidated == 0 && data.item.erpsource == 1"
          >
            <b-button
              v-if="data.item.tglaktifconsol == tglaktifconsol"
              class="btn btn-success sm"
              @click="unlockPeriodeUnit(data.item)"
            >
              UnLock</b-button
            >
            <b-button
              v-else
              class="btn btn-danger sm"
              @click="lockPeriodeUnit(data.item)"
            >
              Lock</b-button
            >
          </div>
          <div
            class="text-center"
            v-if="data.item.consolidated == 1 && data.item.erpsource == 1"
          >
            <b-button
              v-if="data.item.tglsuperholding == tglaktifconsol"
              class="btn btn-success sm"
              @click="unlockPeriodeUnit(data.item)"
            >
              UnLock</b-button
            >
            <b-button
              v-else
              class="btn btn-danger sm"
              @click="lockPeriodeUnit(data.item)"
            >
              Lock</b-button
            >
          </div>
        </template>
      </b-table>
    </b-modal>

    <b-modal
      v-model="showJv_auto"
      header-bg-variant="primary"
      title="Jurnal Eliminasi Otomatis(dari template)"
      size="xl"
      :centered="true"
      :busy="true"
    >
      <b-table
        class="mb-0"
        ref="tblJv_auto"
        outlined
        responsive
        hover
        small
        :items="jv_auto.list"
        :fields="jv_auto.tblFields"
        :per-page="20"
      >
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(kodeacc)="data">
          {{ data.item.kodeacc }} | {{ data.item.namaacc }}
        </template>
        <template v-slot:cell(umasuk)="data">
          {{ data.item.umasuk | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(ukeluar)="data">
          {{ data.item.ukeluar | numFormat("0,0.00") }}
        </template>
        <template slot="bottom-row" slot-scope="data">
          <td colspan="3"></td>
          <td
            style="
              text-align: right;
              font-weight: bold;
              border-top: 2px solid #000 !important;
              background: #e6e6e6;
            "
          >
            TOTAL ({{ user.matauang }})
          </td>
          <td
            style="
              text-align: right;
              font-weight: bold;
              border-top: 2px solid #000 !important;
              background: #e6e6e6;
            "
          >
            {{ totalDb | numFormat("0,0.00") }}
          </td>
          <td
            style="
              text-align: right;
              font-weight: bold;
              border-top: 2px solid #000 !important;
              background: #e6e6e6;
            "
          >
            {{ totalCr | numFormat("0,0.00") }}
          </td>
        </template>
      </b-table>
      <b-row class="justify-content-center mt-2">
        <b-button variant="primary" @click="jv_auto_save()"
          ><i class="fa fa-save"></i> Save</b-button
        >
        <b-button variant="secondary" @click="showJv_auto = false">
          <i class="fa fa-close"></i> Close</b-button
        >
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueMonthlyPicker from "vue-monthly-picker";
import lkuCoa from "../lookup/lkuCoa";
import buku from "../../apis/consolidabuku";
import crud from "../../apis/crud";
import consolidasi from "../../apis/consolidatb";
import dropdown from "../../data/dropdown";
import vNumber from "vue-numeric";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
      tgl1: { required },
      tgl2: { required },
    },
  },
  components: { Loading, vNumber, VueMonthlyPicker, lkuCoa },
  data() {
    return {
      enableLockPeriode: true,
      user: this.$store.state.user,
      dataReady: false,
      frmdata: {
        tgl1: "",
        tgl2: "",
        page: 1,
        limit: 20,
        total: 0,
        periode: moment(this.$store.state.user.tglaktif, "YYYY-MM-DD"),
      },
      isLoading: false,
      reportUrl: null,
      showReport: false,
      tglaktifconsol: this.$store.state.user.tglaktifconsol,
      tahun: moment(this.$store.state.user.tglaktifconsol).format("YYYY"),
      lkuCoaShow: false,
      lkuCoaCaller: "kodeaw",
      wsLines: [],
      wsfiltered: [],
      wsDisplayed: [],
      companies: [],
      monthLabels: dropdown.monthLabels,
      filter: null,
      filterOn: null,
      filterShow: "Show",
      showUnitPeriode: false,
      tblUnitFields: [
        {
          key: "nomor",
          thStyle: "width:50px",
          label: "No.",
        },
        {
          key: "company",
          label: "Company Brand Name",
          sortable: true,
        },
        {
          key: "npwp_name",
          label: "NPWP Name",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thClass: "text-center",
        },
      ],
      jv_auto: {
        list: [],
        tblFields: [
          {
            key: "index",
            label: "No.",
            thStyle: "width:20px",
          },
          {
            key: "company",
            label: "Company",
            thStyle: "width:150px",
          },
          {
            key: "kodeacc",
            label: "Account",
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "umasuk",
            label: "Debit",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "ukeluar",
            label: "Credit",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
        ],
      },
      totalDb: 0,
      totalCr: 0,
      showJv_auto: false,
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function () {
    this.tahun = this.frmdata.periode.format("YYYY");
    this.tglaktifconsol = this.frmdata.periode.format("YYYY-MM-DD");
    // console.log('this.tglaktifconsol: ', this.tglaktifconsol);

    this.companies = await crud.list({
      tablename: "consolidation-member",
      customQuery: "holdingcode=" + encodeURIComponent(this.user.compcode),
      sortBy: "sahamholding",
      sortDesc: true,
    });
    this.companies.forEach((kol, idx) => {
      kol.namakolom = `K${kol.compcode.replace(/[\W_]+/g, "")}`;
      //replace all non Alpha Numeric characters, New Lines, and multiple Whitespace
      kol.compcolor = "#" + this.getRandomColor();
    });
    // console.log('this.companies: ', this.companies);
    this.$watch("filter", function (newVal) {
      setTimeout(() => {
        if (newVal) {
          this.wsfiltered = this.wsLines.filter((line) => {
            if (line) {
              return (
                line.kodeacc.includes(this.filter) ||
                line.namaacc.includes(this.filter)
              );
            } else {
              return false;
            }
          });
        } else {
          this.wsfiltered = JSON.parse(JSON.stringify(this.wsLines));
        }
        this.frmdata.page = 1;
        this.frmdata.total = this.wsLines.length;
        this.paginate(this.wsfiltered);
      }, 100);
    });
    this.$watch("filterShow", function (newVal) {
      if (newVal == "Show") {
        this.filter = "";
      }
    });
    this.$watch("frmdata.page", function (newVal) {
      setTimeout(() => {
        this.paginate(this.wsfiltered);
      }, 100);
    });
    this.$watch("frmdata.limit", function (newVal) {
      setTimeout(() => {
        this.paginate(this.wsfiltered);
      }, 100);
    });

    const filter = this.$store.state.filter;
    let filtered = false;
    for (var key in filter.consolwp) {
      this.frmdata[key] = filter.consolwp[key];
      filtered = true;
    }
    if (filtered == true) {
      this.process();
    }

    // this.dataReady=!this.dataReady;
  },
  methods: {
    onChangeMonth: async function () {
      var tgl = moment(this.frmdata.periode);
      this.frmdata.tgl1 = tgl.startOf("month").format("YYYY-MM-DD");
      this.frmdata.tgl2 = tgl.endOf("month").format("YYYY-MM-DD");
      this.tahun = tgl.format("YYYY");
      //   var tglaktifconsol = this.$store.state.user.tglaktifconsol;
      //   if  (this.tglaktifconsol< this.frmdata.tgl1) {
      if (this.tglaktifconsol == this.frmdata.tgl1) {
        this.enableLockPeriode = true;
      } else {
        this.enableLockPeriode = false;
      }
      this.$forceUpdate();
    },
    getRandomColor() {
      // return Math.floor(Math.random()*16777215).toString(16);
      var letters = "abcdef".split("");
      var color = "";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * letters.length)];
      }
      return color;
    },
    updateTgl1: function () {
      var tgl2 = moment(this.frmdata.tgl2, "YYYY-MM-DD");
      this.frmdata.tgl1 = `${tgl2.format("YYYY-MM")}-01`;
      this.tahun = tgl2.format("YYYY");
      // this.$forceUpdate();
    },
    addjv: function () {
      this.onChangeMonth();
      if (this.invalidFrmdata) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.saveFrmdata();
        router.push({
          name: "consolidation.jurnalfrm",
          params: { tanggal: moment(this.frmdata.tgl2).format("YYYY-MM-DD") },
        });
      }
    },
    addjv_auto: async function () {
      this.onChangeMonth();
      if (this.invalidFrmdata) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.saveFrmdata();
        this.isLoading = true;
        try {
          const eliTmp = await crud.list({
            tablename: "elimination-template",
            customQuery:
              "holdingcode=" + encodeURIComponent(this.user.compcode),
            sortBy: "uraian",
            sortDesc: true,
          });
          console.log("eliTmp: ", eliTmp);
          if (eliTmp) {
            const jurnal = [];
            eliTmp.forEach((tmp) => {
              const db = this.wsLines.find((l) => l.kodeacc == tmp.kodeacc_db);
              const cr = this.wsLines.find((l) => l.kodeacc == tmp.kodeacc_cr);
              if (db && cr) {
                const namakolom_db = `K${tmp.compcode_db.replace(
                  /[\W_]+/g,
                  ""
                )}`;
                const namakolom_cr = `K${tmp.compcode_cr.replace(
                  /[\W_]+/g,
                  ""
                )}`;
                const totTrx =
                  db[namakolom_db] > cr[namakolom_cr]
                    ? cr[namakolom_cr]
                    : db[namakolom_db];
                if (totTrx) {
                  jurnal.push({
                    kodeacc: db.kodeacc,
                    namaacc: db.namaacc,
                    uraian: tmp.uraian,
                    umasuk: totTrx,
                    ukeluar: 0,
                    tanggal: this.frmdata.tgl2,
                  });
                }
                jurnal.push({
                  kodeacc: cr.kodeacc,
                  namaacc: cr.namaacc,
                  uraian: tmp.uraian,
                  umasuk: 0,
                  ukeluar: totTrx,
                  tanggal: this.frmdata.tgl2,
                });
              }
            });
            if (jurnal.length > 1) {
              this.jv_auto.list = jurnal;
              let totalDb = 0;
              let totalCr = 0;
              this.jv_auto.list.forEach((trx) => {
                totalDb = totalDb + parseFloat(trx.umasuk || 0);
                totalCr = totalCr + parseFloat(trx.ukeluar || 0);
              });
              this.totalDb = totalDb;
              this.totalCr = totalCr;
              this.showJv_auto = true;
            } else {
              toastr.warn(
                "No Data suitable to Template",
                "Elimation Template",
                5000
              );
            }
          }
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    jv_auto_save: async function () {
      console.log("Save Clicked");
      // if (!this.saveEnabled) {
      //     toastr.error('View mode cannot be Saved');
      //     return;
      // }
      if (Math.abs(this.totalDb - this.totalCr) > 0.5) {
        toastr.error("Amount DEBIT & CREDIT not Balance ", "ERROR MESSAGE");
      } else {
        try {
          let tanggal = moment(this.frmdata.tgl2, "YYYY-MM-DD");
          let row = { nomor: "", tanggal, lines: this.jv_auto.list };
          await buku.insert(row);
          toastr.success("Complete successfully", "Save Jurnal Eliminasi");
          this.close();
        } catch (error) {
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    saveFrmdata() {
      const consolwp = {};
      for (const key in this.frmdata) {
        consolwp[key] = this.frmdata[key];
      }
      consolwp.page = this.frmdata.page;
      consolwp.limit = this.frmdata.limit;
      const filter = this.$store.state.filter;
      filter.consolwp = consolwp;
      this.$store.commit("filter", filter);
    },
    lockPeriodeUnit: async function (data) {
      // this.onChangeMonth();
      toastr.info(
        `Do Import Trial Balance ${moment(this.tglaktifconsol).format(
          "MMM YYYY"
        )} , System will do Auto Lock the Periode `,
        "Information",
        5000
      );
    },
    unlockPeriodeUnit: async function (data) {
      // this.onChangeMonth();
      toastr.info(
        `UnLock ${data.company} Transactions, Periode ${moment(
          this.tglaktifconsol
        ).format("MMM YYYY")} `,
        "Information",
        5000
      );
      try {
        this.isLoading = true;
        const tgl1 = moment(this.tglaktifconsol, "YYYY-MM-DD")
          .subtract(1, "M")
          .format("YYYY-MM-DD");
        const user = await consolidasi.unlockperiode({
          compcode: data.compcode,
          consolidated: data.consolidated,
          tgl1,
          tg2: this.tglaktifconsol,
        });
        data.tglaktifconsol = user.tglaktifconsol;
        data.tglsuperholding = user.tglsuperholding;

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    process: async function () {
      this.onChangeMonth();
      if (this.invalidFrmdata) {
        const invalidobj = {};
        for (var key in this.$v.frmdata) {
          if (this.$v.frmdata[key].$anyError) {
            if (this.$v.frmdata[key].$anyError == true)
              invalidobj[key] = this.$v.frmdata[key];
          }
        }
        console.log("validation frmdata: ", this.$v.frmdata);
        console.log("validation field: ", invalidobj);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
          this.wsLines = await consolidasi.kertaskerja(this.frmdata);
          this.frmdata.total = this.wsLines.length;
          if (this.wsLines) {
            this.wsfiltered = JSON.parse(JSON.stringify(this.wsLines));
            this.paginate(this.wsfiltered);
          }
          this.dataReady = !this.dataReady;
          this.enableLockPeriode = true;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    paginate(array) {
      this.wsDisplayed = array.slice(
        (this.frmdata.page - 1) * this.frmdata.limit,
        this.frmdata.page * this.frmdata.limit
      );
    },
    showAll() {
      this.frmdata.page = 1;
      this.frmdata.limit = this.frmdata.total;
      this.filter = "";
    },

    exportxls: async function () {
      this.onChangeMonth();
      if (this.invalidFrmdata) {
        console.log("model obj : ", this.frmdata);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await consolidasi.kertaskerjaexport(this.frmdata);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "consolidation_worksheet.xlsx");
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);

          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    // drillGL: function(data){
    //     console.log('drill down to GL : ',data);
    //         let routeData = router.resolve({path: `general-ledger/${data.kodeacc}/${this.frmdata.tgl1}/${this.frmdata.tgl2}`});
    //         window.open(routeData.href, '_blank');

    // },
    showLkuCoa(callerObj) {
      this.lkuCoaShow = true;
      this.lkuCoaCaller = callerObj;
    },
    onSelectLkuCoa(_selected) {
      if (this.lkuCoaCaller === "kodeaw") {
        this.frmdata.kodeawinfo =
          _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
        this.frmdata.kodeaw = _selected.kodeacc;
      } else {
        this.frmdata.kodeakinfo =
          _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
        this.frmdata.kodeak = _selected.kodeacc;
      }
      this.lkuCoaShow = false;
      this.$forceUpdate();
    },
    close() {
      router.push("home");
    },
  },
};
</script>
